// 写入 token
const token_ptk = (new URLSearchParams(location.search)).get('_ptk_');
if (token_ptk) {
  const token = localStorage.getItem('token');
  
  if (!token) {
    sessionStorage.setItem('token_ptk', token_ptk);
    location.href = '/login';
  }
}

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store.js';

import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import i18n from '@/common/lang/index';
Vue.use(ElementUI, {
  size: 'medium',
  i18n: (key, value) => i18n.t(key, value)
});

import './assets/css/element-variables.scss';
import '../public/css/custom-made.css';
// import $ from 'jquery';

import '@/assets/css/normalize.css';
import '@/assets/font/font.css';
import '@/assets/css/common.css';
import '@/assets/css/rewriteEl.scss';
import '@/assets/css/responsinator.scss';
import copy from '@/common/plugins/copy.js';
Vue.prototype.copy = copy;

import Print from '@/common/plugins/print.js';
Vue.prototype.$print = Print;

import henceforward from '@/common/plugins/henceforward.js';
Vue.prototype.$henceforward = henceforward;

import DonMessage from './common/plugins/element';
Vue.prototype.$message = new DonMessage();

import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'
Vue.prototype.$tinymce = tinymce // 将全局tinymce对象指向给Vue作用域下
Vue.use(VueTinymce); // 安装vue的tinymce组件

import VueBus from 'vue-bus';
Vue.use(VueBus);

import ECharts from 'vue-echarts/components/ECharts.vue';
Vue.component('v-chart', ECharts);

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

import Int from '@/common/directive/validate';
import Axios from 'axios';
Vue.directive('Int', Int);

import moment from 'moment'
Vue.prototype.$moment = moment;

// google-analyze自定义指令
import ga from '@/common/directive/analyst'
Vue.use(ga);
import googleAnalyze from '@/utils/google-analyze.js'
Vue.prototype.$ga = googleAnalyze;

// 若是没有开启Devtools工具，在开发环境中开启，在生产环境中关闭
Vue.config.devtools = true;
Vue.config.productionTip = false;

// 检测WebP支持
window.webp = false;

function detectWebP(callback) {
  let webP = new Image();

  webP.onload = webP.onerror = function () {
    callback(webP.height == 2);
  };

  webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
};

detectWebP(supported => window.webp = supported);

Vue.prototype.ossImg = (urls, width, height, updatedTime) => {
  const ossDomains = [
    'erp-goods-images.oss-cn-shenzhen.aliyuncs.com',
    'erp-goods-images.oss-accelerate.aliyuncs.com',
    'jux.bio',
  ];

  if (typeof urls === 'string' && ossDomains.indexOf((new URL(urls)).hostname) === -1) {
    return urls;
  }

  let ossParams = [],
    queryParams = [];
  Object.entries({
    w_: width,
    h_: height
  }).forEach(item => {
    const [key, val] = item;
    let newVal;
    if (val && (newVal = parseInt(val)) > 0) {
      ossParams.push(`${key}${newVal}`);
    }
  });

  // resize
  ossParams.length > 0 && ossParams.unshift('image/resize,m_fill');

  // webp
  window.webp && ossParams.unshift('image/format,webp');

  // oss params
  ossParams.length > 0 && queryParams.push(`x-oss-process=${ossParams.join(',')}`);

  // updatedTime
  updatedTime && queryParams.push(`t=${updatedTime.replace(/[^0-9]+/g,'')}`);

  // query
  const query = queryParams.length > 0 && `?${queryParams.join('&')}` || '';

  if (urls instanceof Array) {
    return urls.map(url => url + (ossDomains.indexOf((new URL(urls)).hostname) > -1 && query.replace(',image/', '/') || ''));
  }

  return urls + query.replace(',image/', '/');
};

// 验证网络图片地址
Vue.prototype.isImlUrl = (val) => {
  return /^https?:\/\/(.+\/)+.+(\.(gif|png|jpg|jpeg|webp|svg|psd|bmp|tif))(<br\/>)*$/i.test(val)
}

const that = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

export default that;